(function () {
	let swiperInstance = null;

	function initSwiper() {
		const sliderDemo = document.querySelector(".home_page_slider.home-page-mobile-slider");

		let sliderMobileDemo = false;
		if (sliderDemo) {
			sliderMobileDemo = true;
		}

		if ((window.innerWidth > 1100 || sliderMobileDemo) && !swiperInstance) {
			const wrapper = document.querySelector(".slider-demo-wrapper");
			wrapper.classList.add("swiper-wrapper");

			const elements = document.querySelectorAll(
				".slider-demo > .swiper-wrapper > *"
			);

			elements.forEach((element) => {
				element.classList.add("swiper-slide");
			});

			swiperInstance = new Swiper(".slider-demo", {
				direction: "vertical",
				speed: 400,
				effect: "creative",
				creativeEffect: {
					prev: {
						translate: [0, "-20%", -1],
					},
					next: {
						translate: [0, "100%", 0],
					},
				},
				mousewheel: {
					forceToAxis: true,
					releaseOnEdges: false,
					sensitivity: 1,
					thresholdDelta: 20,
					thresholdTime: 200,
				},
				touchReleaseOnEdges: false,
				touchRatio: 0.2,
				longSwipes: true,
				freeMode: false,
				on: {
					slideChangeTransitionStart: changeNavStyle,
				},
			});

			changeNavStyle();

			function changeNavStyle() {
				const stickyNav = document.querySelector(".shopify-section-header");
				const activeSection = document.querySelector(
					".slider-demo > .swiper-wrapper > .swiper-slide-active"
				);
				const overlaySection = activeSection?.querySelector(
					".section--has-overlay[data-header-contrast]"
				);
				const headerContrast = overlaySection?.dataset.headerContrast;

				if (headerContrast === "light" || headerContrast === "dark") {
					stickyNav.dataset.overlayContrast = headerContrast;
					stickyNav.classList.add("color-background-1", "color-background-2");
					return;
				}

				stickyNav.dataset.overlayContrast = "dark";
				stickyNav.classList.add("color-background-1", "color-background-2");
			}
		} else if (window.innerWidth <= 1100 && !sliderMobileDemo) {
			swiperInstance && swiperInstance.destroy(true, true);
			swiperInstance = null; // Clear the instance after destroying
			const wrapper = document.querySelector(".slider-demo-wrapper");
			wrapper.classList.remove("swiper-wrapper");
		}
	}

	initSwiper();

	window.addEventListener("resize", function () {
		initSwiper();
	});
	document.addEventListener("shopify:section:load", function () {
		initSwiper();
	});
})();
